import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/shared/ui/hooks'
import { isBypassedPath } from './public-route-paths'

export function PublicRoute() {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return null
  }

  if (user && !isBypassedPath(location.pathname)) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
